export default __webpack_public_path__ + "static/media/vcfo-logo-white-cms.8d14768e.png";